/**
 * 涨跌幅箭头图标
 * @param isUp - 是否上涨
 */
export function ChangeArrow( { isUp }: { isUp: boolean } ) {
    return (
        <svg
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ transform: isUp ? "none" : "rotate(180deg)" }}
        >
            <rect
                width="12"
                height="12"
                transform="matrix(-1 0 0 1 12 0)"
                fill="transparent"
            />
            <path
                d="M4.75133 2.82404C5.31033 1.98704 6.68933 1.98704 7.24733 2.82404L10.3463 7.47204C10.6543 7.93304 10.6823 8.52304 10.4203 9.01204C10.1583 9.50104 9.65133 9.80404 9.09833 9.80404H2.90133C2.34733 9.80404 1.84032 9.50104 1.57932 9.01204C1.31732 8.52404 1.34632 7.93304 1.65333 7.47204L4.75133 2.82404Z"
                fill={isUp ? "#09C285" : "#ef4444"}
            />
        </svg>
    );
}
